// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import { backgroundColor, BackgroundColorProps, borderColor, BorderColorProps } from '../styled/color';

interface CircleProps {
  size: string | number;
}

export default styled.div<CircleProps & BackgroundColorProps & BorderColorProps>`
  border-radius: 100%;
  width: ${({ size }) => typeof size === 'number' ? `${size}px` : size};
  height: ${({ size }) => typeof size === 'number' ? `${size}px` : size};
  ${backgroundColor}
  ${borderColor}
`
